module.exports = __webpack_public_path__ + "img/banner-TV-2__sm.dac06a29.jpg";